import * as React from 'react';
import { connect } from 'react-redux';
import metricStoreConfigService from 'kayenta/metricStore/metricStoreConfig.service';
function MetricConfigurerDelegator({ editingMetric }) {
    const config = metricStoreConfigService.getDelegate(editingMetric.query.type);
    if (config && config.metricConfigurer) {
        const MetricConfigurer = config.metricConfigurer;
        return React.createElement(MetricConfigurer, null);
    }
    else {
        return React.createElement("p", null,
            "Metric configuration has not been implemented for ",
            editingMetric.query.type,
            ".");
    }
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
export default connect(mapStateToProps)(MetricConfigurerDelegator);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0cmljQ29uZmlndXJlckRlbGVnYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9rYXllbnRhL2VkaXQvbWV0cmljQ29uZmlndXJlckRlbGVnYXRvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDL0IsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUV0QyxPQUFPLHdCQUF3QixNQUFNLCtDQUErQyxDQUFDO0FBVXJGLFNBQVMseUJBQXlCLENBQUMsRUFBRSxhQUFhLEVBQXdDO0lBQ3hGLE1BQU0sTUFBTSxHQUFHLHdCQUF3QixDQUFDLFdBQVcsQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlFLElBQUksTUFBTSxJQUFJLE1BQU0sQ0FBQyxnQkFBZ0IsRUFBRTtRQUNyQyxNQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQztRQUNqRCxPQUFPLG9CQUFDLGdCQUFnQixPQUFHLENBQUM7S0FDN0I7U0FBTTtRQUNMLE9BQU87O1lBQXNELGFBQWEsQ0FBQyxLQUFLLENBQUMsSUFBSTtnQkFBTSxDQUFDO0tBQzdGO0FBQ0gsQ0FBQztBQUVELFNBQVMsZUFBZSxDQUFDLEtBQW1CO0lBQzFDLE9BQU87UUFDTCxhQUFhLEVBQUUsS0FBSyxDQUFDLGNBQWMsQ0FBQyxhQUFhO0tBQ2xELENBQUM7QUFDSixDQUFDO0FBRUQsZUFBZSxPQUFPLENBQUMsZUFBZSxDQUFDLENBQUMseUJBQXlCLENBQUMsQ0FBQyJ9